/**
 * Upper-cases the first char of input string
 *
 * @param input String to be capitalized.
 * @returns Capitalized version of input string.
 */
export function capitalize(input) {
    return `${input.charAt(0).toUpperCase()}${input.substring(1)}`;
}
//# sourceMappingURL=capitalize.js.map